import React from 'react'
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap'
import FormCard from '../common/FormCard'

function UsersCreateCard({
  formData,
  errors,
  submitted,
  isSaving,
  errorMessage,
  successMessage,
  onInputChange,
  onSubmit,
  isWholesaler = false,
}) {
  return (
    <FormCard
      title="Registrar usuario"
      onSubmit={onSubmit}
      submitLabel="Registrar"
      isSubmitting={isSaving}
      errorMessage={errorMessage}
      successMessage={successMessage}
    >
      <FormGroup>
        <Label for="username">
          Usuario <span className="text-danger">*</span>
        </Label>
        <Input
          type="text"
          name="username"
          id="username"
          placeholder="Ingrese el usuario"
          value={formData.username}
          onChange={onInputChange}
          invalid={submitted && !!errors.username}
        />
        {submitted && errors.username && (
          <FormFeedback>{errors.username}</FormFeedback>
        )}
      </FormGroup>

      <FormGroup>
        <Label for="password">
          Contraseña <span className="text-danger">*</span>
        </Label>
        <Input
          type="password"
          name="password"
          id="password"
          placeholder="Ingrese la contraseña"
          value={formData.password}
          onChange={onInputChange}
          invalid={submitted && !!errors.password}
        />
        {submitted && errors.password && (
          <FormFeedback>{errors.password}</FormFeedback>
        )}
      </FormGroup>

      <FormGroup>
        <Label for="role">
          Rol <span className="text-danger">*</span>
        </Label>
        <Input
          type="select"
          name="role"
          id="role"
          value={formData.role}
          onChange={onInputChange}
          disabled={isWholesaler}
          invalid={submitted && !!errors.role}
        >
          {isWholesaler ? (
            <option value="DISTRIBUTOR">Distributor</option>
          ) : (
            <>
              <option value="ADMIN">Admin</option>
              <option value="WHOLESALER">Mayorista</option>
              <option value="DISTRIBUTOR">Distributor</option>
            </>
          )}
        </Input>
        {submitted && errors.role && (
          <FormFeedback>{errors.role}</FormFeedback>
        )}
      </FormGroup>

      {formData.role === 'WHOLESALER' && (
        <FormGroup>
          <Label for="wholesaler">Mayorista</Label>
          <Input
            type="text"
            name="wholesaler"
            id="wholesaler"
            placeholder="Nombre del wholesaler"
            value={formData.wholesaler}
            onChange={onInputChange}
          />
        </FormGroup>
      )}
    </FormCard>
  )
}

export default UsersCreateCard
